/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { StudentEngagementRosterInfo } from './studentEngagementRosterInfo';

export type GenericApiResponseStudentEngagementRosterInfoData = StudentEngagementRosterInfo | null;
